export const phoneExtensions = [
  {
    "name_en": "Albania",
    "name_es": "Albania",
    "dial_code": "+355",
    "code_2": "AL",
    "code_3": "ALB"
  },
  {
    "name_en": "Germany",
    "name_es": "Alemania",
    "dial_code": "+49",
    "code_2": "DE",
    "code_3": "DEU"
  },
  {
    "name_en": "Andorra",
    "name_es": "Andorra",
    "dial_code": "+376",
    "code_2": "AD",
    "code_3": "AND"
  },
  {
    "name_en": "Anguilla",
    "name_es": "Anguilla",
    "dial_code": "+1264",
    "code_2": "AI",
    "code_3": "AIA"
  },
  {
    "name_en": "Antigua and Barbuda",
    "name_es": "Antigua y Barbuda",
    "dial_code": "+1268",
    "code_2": "AG",
    "code_3": "ATG"
  },
  {
    "name_en": "Antarctica",
    "name_es": "Antártida",
    "dial_code": "+672",
    "code_2": "AQ",
    "code_3": "ATA"
  },
  {
    "name_en": "Saudi Arabia",
    "name_es": "Arabia Saudita",
    "dial_code": "+966",
    "code_2": "SA",
    "code_3": "SAU"
  },
  {
    "name_en": "Argentina",
    "name_es": "Argentina",
    "dial_code": "+54",
    "code_2": "AR",
    "code_3": "ARG"
  },
  {
    "name_en": "Armenia",
    "name_es": "Armenia",
    "dial_code": "+374",
    "code_2": "AM",
    "code_3": "ARM"
  },
  {
    "name_en": "Aruba",
    "name_es": "Aruba",
    "dial_code": "+297",
    "code_2": "AW",
    "code_3": "ABW"
  },
  {
    "name_en": "Australia",
    "name_es": "Australia",
    "dial_code": "+61",
    "code_2": "AU",
    "code_3": "AUS"
  },
  {
    "name_en": "Austria",
    "name_es": "Austria",
    "dial_code": "+43",
    "code_2": "AT",
    "code_3": "AUT"
  },
  {
    "name_en": "Azerbaijan",
    "name_es": "Azerbaiyán",
    "dial_code": "+994",
    "code_2": "AZ",
    "code_3": "AZE"
  },
  {
    "name_en": "Bahamas",
    "name_es": "Bahamas",
    "dial_code": "+1242",
    "code_2": "BS",
    "code_3": "BHS"
  },
  {
    "name_en": "Bangladesh",
    "name_es": "Bangladés",
    "dial_code": "+880",
    "code_2": "BD",
    "code_3": "BGD"
  },
  {
    "name_en": "Barbados",
    "name_es": "Barbados",
    "dial_code": "+1246",
    "code_2": "BB",
    "code_3": "BRB"
  },
  {
    "name_en": "Bahrain",
    "name_es": "Baréin",
    "dial_code": "+973",
    "code_2": "BH",
    "code_3": "BHR"
  },
  {
    "name_en": "Belize",
    "name_es": "Belice",
    "dial_code": "+501",
    "code_2": "BZ",
    "code_3": "BLZ"
  },
  {
    "name_en": "Bermuda",
    "name_es": "Bermudas",
    "dial_code": "+1441",
    "code_2": "BM",
    "code_3": "BMU"
  },
  {
    "name_en": "Belarus",
    "name_es": "Bielorrusia",
    "dial_code": "+375",
    "code_2": "BY",
    "code_3": "BLR"
  },
  {
    "name_en": "Bolivia",
    "name_es": "Bolivia",
    "dial_code": "+591",
    "code_2": "BO",
    "code_3": "BOL"
  },
  {
    "name_en": "Bonaire, Sint Eustatius and Saba",
    "name_es": "Bonaire, San Eustaquio y Saba",
    "dial_code": "+599",
    "code_2": "BQ",
    "code_3": "BES"
  },
  {
    "name_en": "Bosnia and Herzegovina",
    "name_es": "Bosnia y Herzegovina",
    "dial_code": "+387",
    "code_2": "BA",
    "code_3": "BIH"
  },
  {
    "name_en": "Brazil",
    "name_es": "Brasil",
    "dial_code": "+55",
    "code_2": "BR",
    "code_3": "BRA"
  },
  {
    "name_en": "Brunei Darussalam",
    "name_es": "Brunéi",
    "dial_code": "+673",
    "code_2": "BN",
    "code_3": "BRN"
  },
  {
    "name_en": "Bulgaria",
    "name_es": "Bulgaria",
    "dial_code": "+359",
    "code_2": "BG",
    "code_3": "BGR"
  },
  {
    "name_en": "Bhutan",
    "name_es": "Bután",
    "dial_code": "+975",
    "code_2": "BT",
    "code_3": "BTN"
  },
  {
    "name_en": "Belgium",
    "name_es": "Bélgica",
    "dial_code": "+32",
    "code_2": "BE",
    "code_3": "BEL"
  },
  {
    "name_en": "Cambodia",
    "name_es": "Camboya",
    "dial_code": "+855",
    "code_2": "KH",
    "code_3": "KHM"
  },
  {
    "name_en": "Canada",
    "name_es": "Canadá",
    "dial_code": "+1",
    "code_2": "CA",
    "code_3": "CAN"
  },
  {
    "name_en": "Qatar",
    "name_es": "Catar",
    "dial_code": "+974",
    "code_2": "QA",
    "code_3": "QAT"
  },
  {
    "name_en": "Czechia",
    "name_es": "Chequia",
    "dial_code": "+420",
    "code_2": "CZ",
    "code_3": "CZE"
  },
  {
    "name_en": "Chile",
    "name_es": "Chile",
    "dial_code": "+56",
    "code_2": "CL",
    "code_3": "CHL"
  },
  {
    "name_en": "China",
    "name_es": "China",
    "dial_code": "+86",
    "code_2": "CN",
    "code_3": "CHN"
  },
  {
    "name_en": "Cyprus",
    "name_es": "Chipre",
    "dial_code": "+357",
    "code_2": "CY",
    "code_3": "CYP"
  },
  {
    "name_en": "Vatican City State",
    "name_es": "Ciudad del Vaticano",
    "dial_code": "+379",
    "code_2": "VA",
    "code_3": "VAT"
  },
  {
    "name_en": "Colombia",
    "name_es": "Colombia",
    "dial_code": "+57",
    "code_2": "CO",
    "code_3": "COL"
  },
  {
    "name_en": "North Korea",
    "name_es": "Corea del Norte",
    "dial_code": "+850",
    "code_2": "KP",
    "code_3": "PRK"
  },
  {
    "name_en": "South Korea",
    "name_es": "Corea del Sur",
    "dial_code": "+82",
    "code_2": "KR",
    "code_3": "KOR"
  },
  {
    "name_en": "Costa Rica",
    "name_es": "Costa Rica",
    "dial_code": "+506",
    "code_2": "CR",
    "code_3": "CRI"
  },
  {
    "name_en": "Croatia",
    "name_es": "Croacia",
    "dial_code": "+385",
    "code_2": "HR",
    "code_3": "HRV"
  },
  {
    "name_en": "Cuba",
    "name_es": "Cuba",
    "dial_code": "+53",
    "code_2": "CU",
    "code_3": "CUB"
  },
  {
    "name_en": "Curaçao",
    "name_es": "Curazao",
    "dial_code": "+599",
    "code_2": "CW",
    "code_3": "CUW"
  },
  {
    "name_en": "Denmark",
    "name_es": "Dinamarca",
    "dial_code": "+45",
    "code_2": "DK",
    "code_3": "DNK"
  },
  {
    "name_en": "Dominica",
    "name_es": "Dominica",
    "dial_code": "+1767",
    "code_2": "DM",
    "code_3": "DMA"
  },
  {
    "name_en": "Ecuador",
    "name_es": "Ecuador",
    "dial_code": "+593",
    "code_2": "EC",
    "code_3": "ECU"
  },
  {
    "name_en": "El Salvador",
    "name_es": "El Salvador",
    "dial_code": "+503",
    "code_2": "SV",
    "code_3": "SLV"
  },
  {
    "name_en": "United Arab Emirates",
    "name_es": "Emiratos Árabes Unidos",
    "dial_code": "+971",
    "code_2": "AE",
    "code_3": "ARE"
  },
  {
    "name_en": "Slovakia",
    "name_es": "Eslovaquia",
    "dial_code": "+421",
    "code_2": "SK",
    "code_3": "SVK"
  },
  {
    "name_en": "Slovenia",
    "name_es": "Eslovenia",
    "dial_code": "+386",
    "code_2": "SI",
    "code_3": "SVN"
  },
  {
    "name_en": "Spain",
    "name_es": "España",
    "dial_code": "+34",
    "code_2": "ES",
    "code_3": "ESP"
  },
  {
    "name_en": "United States",
    "name_es": "Estados Unidos",
    "dial_code": "+1",
    "code_2": "US",
    "code_3": "USA"
  },
  {
    "name_en": "Estonia",
    "name_es": "Estonia",
    "dial_code": "+372",
    "code_2": "EE",
    "code_3": "EST"
  },
  {
    "name_en": "Philippines",
    "name_es": "Filipinas",
    "dial_code": "+63",
    "code_2": "PH",
    "code_3": "PHL"
  },
  {
    "name_en": "Finland",
    "name_es": "Finlandia",
    "dial_code": "+358",
    "code_2": "FI",
    "code_3": "FIN"
  },
  {
    "name_en": "Fiji",
    "name_es": "Fiyi",
    "dial_code": "+679",
    "code_2": "FJ",
    "code_3": "FJI"
  },
  {
    "name_en": "France",
    "name_es": "Francia",
    "dial_code": "+33",
    "code_2": "FR",
    "code_3": "FRA"
  },
  {
    "name_en": "Georgia",
    "name_es": "Georgia",
    "dial_code": "+995",
    "code_2": "GE",
    "code_3": "GEO"
  },
  {
    "name_en": "Gibraltar",
    "name_es": "Gibraltar",
    "dial_code": "+350",
    "code_2": "GI",
    "code_3": "GIB"
  },
  {
    "name_en": "Grenada",
    "name_es": "Granada",
    "dial_code": "+1473",
    "code_2": "GD",
    "code_3": "GRD"
  },
  {
    "name_en": "Greece",
    "name_es": "Grecia",
    "dial_code": "+30",
    "code_2": "GR",
    "code_3": "GRC"
  },
  {
    "name_en": "Greenland",
    "name_es": "Groenlandia",
    "dial_code": "+299",
    "code_2": "GL",
    "code_3": "GRL"
  },
  {
    "name_en": "Guadeloupe",
    "name_es": "Guadalupe",
    "dial_code": "+590",
    "code_2": "GP",
    "code_3": "GLP"
  },
  {
    "name_en": "Guam",
    "name_es": "Guam",
    "dial_code": "+1671",
    "code_2": "GU",
    "code_3": "GUM"
  },
  {
    "name_en": "Guatemala",
    "name_es": "Guatemala",
    "dial_code": "+502",
    "code_2": "GT",
    "code_3": "GTM"
  },
  {
    "name_en": "French Guiana",
    "name_es": "Guayana Francesa",
    "dial_code": "+594",
    "code_2": "GF",
    "code_3": "GUF"
  },
  {
    "name_en": "Guernsey",
    "name_es": "Guernsey",
    "dial_code": "+44",
    "code_2": "GG",
    "code_3": "GGY"
  },
  {
    "name_en": "Guyana",
    "name_es": "Guyana",
    "dial_code": "+592",
    "code_2": "GY",
    "code_3": "GUY"
  },
  {
    "name_en": "Haiti",
    "name_es": "Haití",
    "dial_code": "+509",
    "code_2": "HT",
    "code_3": "HTI"
  },
  {
    "name_en": "Honduras",
    "name_es": "Honduras",
    "dial_code": "+504",
    "code_2": "HN",
    "code_3": "HND"
  },
  {
    "name_en": "Hong Kong",
    "name_es": "Hong Kong",
    "dial_code": "+852",
    "code_2": "HK",
    "code_3": "HKG"
  },
  {
    "name_en": "Hungary",
    "name_es": "Hungría",
    "dial_code": "+36",
    "code_2": "HU",
    "code_3": "HUN"
  },
  {
    "name_en": "India",
    "name_es": "India",
    "dial_code": "+91",
    "code_2": "IN",
    "code_3": "IND"
  },
  {
    "name_en": "Indonesia",
    "name_es": "Indonesia",
    "dial_code": "+62",
    "code_2": "ID",
    "code_3": "IDN"
  },
  {
    "name_en": "Iraq",
    "name_es": "Irak",
    "dial_code": "+964",
    "code_2": "IQ",
    "code_3": "IRQ"
  },
  {
    "name_en": "Ireland",
    "name_es": "Irlanda",
    "dial_code": "+353",
    "code_2": "IE",
    "code_3": "IRL"
  },
  {
    "name_en": "Iran",
    "name_es": "Irán",
    "dial_code": "+98",
    "code_2": "IR",
    "code_3": "IRN"
  },
  {
    "name_en": "Norfolk Island",
    "name_es": "Isla Norfolk",
    "dial_code": "+672",
    "code_2": "NF",
    "code_3": "NFK"
  },
  {
    "name_en": "Isle of Man",
    "name_es": "Isla de Man",
    "dial_code": "+44",
    "code_2": "IM",
    "code_3": "IMN"
  },
  {
    "name_en": "Christmas Island",
    "name_es": "Isla de Navidad",
    "dial_code": "+61",
    "code_2": "CX",
    "code_3": "CXR"
  },
  {
    "name_en": "Iceland",
    "name_es": "Islandia",
    "dial_code": "+354",
    "code_2": "IS",
    "code_3": "ISL"
  },
  {
    "name_en": "Cayman Islands",
    "name_es": "Islas Caimán",
    "dial_code": "+1345",
    "code_2": "KY",
    "code_3": "CYM"
  },
  {
    "name_en": "Cocos (Keeling) Islands",
    "name_es": "Islas Cocos",
    "dial_code": "+61",
    "code_2": "CC",
    "code_3": "CCK"
  },
  {
    "name_en": "Cook Islands",
    "name_es": "Islas Cook",
    "dial_code": "+682",
    "code_2": "CK",
    "code_3": "COK"
  },
  {
    "name_en": "Faroe Islands",
    "name_es": "Islas Feroe",
    "dial_code": "+298",
    "code_2": "FO",
    "code_3": "FRO"
  },
  {
    "name_en": "South Georgia and the South Sandwich Islands",
    "name_es": "Islas Georgias del Sur y Sandwich del Sur",
    "dial_code": "+500",
    "code_2": "GS",
    "code_3": "SGS"
  },
  {
    "name_en": "Heard Island and McDonald Islands",
    "name_es": "Islas Heard y McDonald",
    "dial_code": "+672",
    "code_2": "HM",
    "code_3": "HMD"
  },
  {
    "name_en": "Falkland Islands (Malvinas)",
    "name_es": "Islas Malvinas",
    "dial_code": "+500",
    "code_2": "FK",
    "code_3": "FLK"
  },
  {
    "name_en": "Northern Mariana Islands",
    "name_es": "Islas Marianas del Norte",
    "dial_code": "+1670",
    "code_2": "MP",
    "code_3": "MNP"
  },
  {
    "name_en": "Marshall Islands",
    "name_es": "Islas Marshall",
    "dial_code": "+692",
    "code_2": "MH",
    "code_3": "MHL"
  },
  {
    "name_en": "Pitcairn",
    "name_es": "Islas Pitcairn",
    "dial_code": "+64",
    "code_2": "PN",
    "code_3": "PCN"
  },
  {
    "name_en": "Solomon Islands",
    "name_es": "Islas Salomón",
    "dial_code": "+677",
    "code_2": "SB",
    "code_3": "SLB"
  },
  {
    "name_en": "Turks and Caicos Islands",
    "name_es": "Islas Turcas y Caicos",
    "dial_code": "+1649",
    "code_2": "TC",
    "code_3": "TCA"
  },
  {
    "name_en": "Virgin Islands, British",
    "name_es": "Islas Vírgenes Británicas",
    "dial_code": "+1284",
    "code_2": "VG",
    "code_3": "VGB"
  },
  {
    "name_en": "Virgin Islands, U.S.",
    "name_es": "Islas Vírgenes de los Estados Unidos",
    "dial_code": "+1340",
    "code_2": "VI",
    "code_3": "VIR"
  },
  {
    "name_en": "Israel",
    "name_es": "Israel",
    "dial_code": "+972",
    "code_2": "IL",
    "code_3": "ISR"
  },
  {
    "name_en": "Italy",
    "name_es": "Italia",
    "dial_code": "+39",
    "code_2": "IT",
    "code_3": "ITA"
  },
  {
    "name_en": "Jamaica",
    "name_es": "Jamaica",
    "dial_code": "+1 876",
    "code_2": "JM",
    "code_3": "JAM"
  },
  {
    "name_en": "Japan",
    "name_es": "Japón",
    "dial_code": "+81",
    "code_2": "JP",
    "code_3": "JPN"
  },
  {
    "name_en": "Jersey",
    "name_es": "Jersey",
    "dial_code": "+44",
    "code_2": "JE",
    "code_3": "JEY"
  },
  {
    "name_en": "Jordan",
    "name_es": "Jordania",
    "dial_code": "+962",
    "code_2": "JO",
    "code_3": "JOR"
  },
  {
    "name_en": "Kazakhstan",
    "name_es": "Kazajistán",
    "dial_code": "+7 7",
    "code_2": "KZ",
    "code_3": "KAZ"
  },
  {
    "name_en": "Kyrgyzstan",
    "name_es": "Kirguistán",
    "dial_code": "+996",
    "code_2": "KG",
    "code_3": "KGZ"
  },
  {
    "name_en": "Kiribati",
    "name_es": "Kiribati",
    "dial_code": "+686",
    "code_2": "KI",
    "code_3": "KIR"
  },
  {
    "name_en": "Kosovo",
    "name_es": "Kosovo",
    "dial_code": "+383",
    "code_2": "XK",
    "code_3": "XKX"
  },
  {
    "name_en": "Kuwait",
    "name_es": "Kuwait",
    "dial_code": "+965",
    "code_2": "KW",
    "code_3": "KWT"
  },
  {
    "name_en": "Laos",
    "name_es": "Laos",
    "dial_code": "+856",
    "code_2": "LA",
    "code_3": "LAO"
  },
  {
    "name_en": "Latvia",
    "name_es": "Letonia",
    "dial_code": "+371",
    "code_2": "LV",
    "code_3": "LVA"
  },
  {
    "name_en": "Liechtenstein",
    "name_es": "Liechtenstein",
    "dial_code": "+423",
    "code_2": "LI",
    "code_3": "LIE"
  },
  {
    "name_en": "Lithuania",
    "name_es": "Lituania",
    "dial_code": "+370",
    "code_2": "LT",
    "code_3": "LTU"
  },
  {
    "name_en": "Luxembourg",
    "name_es": "Luxemburgo",
    "dial_code": "+352",
    "code_2": "LU",
    "code_3": "LUX"
  },
  {
    "name_en": "Lebanon",
    "name_es": "Líbano",
    "dial_code": "+961",
    "code_2": "LB",
    "code_3": "LBN"
  },
  {
    "name_en": "Macao",
    "name_es": "Macao",
    "dial_code": "+853",
    "code_2": "MO",
    "code_3": "MAC"
  },
  {
    "name_en": "North Macedonia",
    "name_es": "Macedonia del Norte",
    "dial_code": "+389",
    "code_2": "MK",
    "code_3": "MKD"
  },
  {
    "name_en": "Malaysia",
    "name_es": "Malasia",
    "dial_code": "+60",
    "code_2": "MY",
    "code_3": "MYS"
  },
  {
    "name_en": "Maldives",
    "name_es": "Maldivas",
    "dial_code": "+960",
    "code_2": "MV",
    "code_3": "MDV"
  },
  {
    "name_en": "Malta",
    "name_es": "Malta",
    "dial_code": "+356",
    "code_2": "MT",
    "code_3": "MLT"
  },
  {
    "name_en": "Martinique",
    "name_es": "Martinica",
    "dial_code": "+596",
    "code_2": "MQ",
    "code_3": "MTQ"
  },
  {
    "name_en": "Micronesia",
    "name_es": "Micronesia",
    "dial_code": "+691",
    "code_2": "FM",
    "code_3": "FSM"
  },
  {
    "name_en": "Moldova",
    "name_es": "Moldavia",
    "dial_code": "+373",
    "code_2": "MD",
    "code_3": "MDA"
  },
  {
    "name_en": "Mongolia",
    "name_es": "Mongolia",
    "dial_code": "+976",
    "code_2": "MN",
    "code_3": "MNG"
  },
  {
    "name_en": "Montenegro",
    "name_es": "Montenegro",
    "dial_code": "+382",
    "code_2": "ME",
    "code_3": "MNE"
  },
  {
    "name_en": "Montserrat",
    "name_es": "Montserrat",
    "dial_code": "+1664",
    "code_2": "MS",
    "code_3": "MSR"
  },
  {
    "name_en": "Myanmar",
    "name_es": "Myanmar",
    "dial_code": "+95",
    "code_2": "MM",
    "code_3": "MMR"
  },
  {
    "name_en": "Mexico",
    "name_es": "México",
    "dial_code": "+52",
    "code_2": "MX",
    "code_3": "MEX"
  },
  {
    "name_en": "Monaco",
    "name_es": "Mónaco",
    "dial_code": "+377",
    "code_2": "MC",
    "code_3": "MCO"
  },
  {
    "name_en": "Nauru",
    "name_es": "Nauru",
    "dial_code": "+674",
    "code_2": "NR",
    "code_3": "NRU"
  },
  {
    "name_en": "Nepal",
    "name_es": "Nepal",
    "dial_code": "+977",
    "code_2": "NP",
    "code_3": "NPL"
  },
  {
    "name_en": "Nicaragua",
    "name_es": "Nicaragua",
    "dial_code": "+505",
    "code_2": "NI",
    "code_3": "NIC"
  },
  {
    "name_en": "Niue",
    "name_es": "Niue",
    "dial_code": "+683",
    "code_2": "NU",
    "code_3": "NIU"
  },
  {
    "name_en": "Norway",
    "name_es": "Noruega",
    "dial_code": "+47",
    "code_2": "NO",
    "code_3": "NOR"
  },
  {
    "name_en": "New Caledonia",
    "name_es": "Nueva Caledonia",
    "dial_code": "+687",
    "code_2": "NC",
    "code_3": "NCL"
  },
  {
    "name_en": "New Zealand",
    "name_es": "Nueva Zelanda",
    "dial_code": "+64",
    "code_2": "NZ",
    "code_3": "NZL"
  },
  {
    "name_en": "Oman",
    "name_es": "Omán",
    "dial_code": "+968",
    "code_2": "OM",
    "code_3": "OMN"
  },
  {
    "name_en": "Pakistan",
    "name_es": "Pakistán",
    "dial_code": "+92",
    "code_2": "PK",
    "code_3": "PAK"
  },
  {
    "name_en": "Palau",
    "name_es": "Palaos",
    "dial_code": "+680",
    "code_2": "PW",
    "code_3": "PLW"
  },
  {
    "name_en": "Palestine",
    "name_es": "Palestina",
    "dial_code": "+970",
    "code_2": "PS",
    "code_3": "PSE"
  },
  {
    "name_en": "Panama",
    "name_es": "Panamá",
    "dial_code": "+507",
    "code_2": "PA",
    "code_3": "PAN"
  },
  {
    "name_en": "Papua New Guinea",
    "name_es": "Papúa Nueva Guinea",
    "dial_code": "+675",
    "code_2": "PG",
    "code_3": "PNG"
  },
  {
    "name_en": "Paraguay",
    "name_es": "Paraguay",
    "dial_code": "+595",
    "code_2": "PY",
    "code_3": "PRY"
  },
  {
    "name_en": "Netherlands",
    "name_es": "Países Bajos",
    "dial_code": "+31",
    "code_2": "NL",
    "code_3": "NLD"
  },
  {
    "name_en": "Peru",
    "name_es": "Perú",
    "dial_code": "+51",
    "code_2": "PE",
    "code_3": "PER"
  },
  {
    "name_en": "French Polynesia",
    "name_es": "Polinesia Francesa",
    "dial_code": "+689",
    "code_2": "PF",
    "code_3": "PYF"
  },
  {
    "name_en": "Poland",
    "name_es": "Polonia",
    "dial_code": "+48",
    "code_2": "PL",
    "code_3": "POL"
  },
  {
    "name_en": "Portugal",
    "name_es": "Portugal",
    "dial_code": "+351",
    "code_2": "PT",
    "code_3": "PRT"
  },
  {
    "name_en": "Puerto Rico",
    "name_es": "Puerto Rico",
    "dial_code": "+1939",
    "code_2": "PR",
    "code_3": "PRI"
  },
  {
    "name_en": "United Kingdom",
    "name_es": "Reino Unido",
    "dial_code": "+44",
    "code_2": "GB",
    "code_3": "GBR"
  },
  {
    "name_en": "Dominican Republic",
    "name_es": "República Dominicana",
    "dial_code": "+1849",
    "code_2": "DO",
    "code_3": "DOM"
  },
  {
    "name_en": "Romania",
    "name_es": "Rumania",
    "dial_code": "+40",
    "code_2": "RO",
    "code_3": "ROU"
  },
  {
    "name_en": "Russia",
    "name_es": "Rusia",
    "dial_code": "+7",
    "code_2": "RU",
    "code_3": "RUS"
  },
  {
    "name_en": "Samoa",
    "name_es": "Samoa",
    "dial_code": "+685",
    "code_2": "WS",
    "code_3": "WSM"
  },
  {
    "name_en": "American Samoa",
    "name_es": "Samoa Americana",
    "dial_code": "+1684",
    "code_2": "AS",
    "code_3": "ASM"
  },
  {
    "name_en": "Saint Barthélemy",
    "name_es": "San Bartolomé",
    "dial_code": "+590",
    "code_2": "BL",
    "code_3": "BLM"
  },
  {
    "name_en": "Saint Kitts and Nevis",
    "name_es": "San Cristóbal y Nieves",
    "dial_code": "+1869",
    "code_2": "KN",
    "code_3": "KNA"
  },
  {
    "name_en": "San Marino",
    "name_es": "San Marino",
    "dial_code": "+378",
    "code_2": "SM",
    "code_3": "SMR"
  },
  {
    "name_en": "Saint Martin",
    "name_es": "San Martín",
    "dial_code": "+590",
    "code_2": "MF",
    "code_3": "MAF"
  },
  {
    "name_en": "Saint Pierre and Miquelon",
    "name_es": "San Pedro y Miquelón",
    "dial_code": "+508",
    "code_2": "PM",
    "code_3": "SPM"
  },
  {
    "name_en": "Saint Vincent and the Grenadines",
    "name_es": "San Vicente y las Granadinas",
    "dial_code": "+1784",
    "code_2": "VC",
    "code_3": "VCT"
  },
  {
    "name_en": "Saint Lucia",
    "name_es": "Santa Lucía",
    "dial_code": "+1758",
    "code_2": "LC",
    "code_3": "LCA"
  },
  {
    "name_en": "Serbia",
    "name_es": "Serbia",
    "dial_code": "+381",
    "code_2": "RS",
    "code_3": "SRB"
  },
  {
    "name_en": "Singapore",
    "name_es": "Singapur",
    "dial_code": "+65",
    "code_2": "SG",
    "code_3": "SGP"
  },
  {
    "name_en": "Sint Maarten",
    "name_es": "Sint Maarten",
    "dial_code": "+1721",
    "code_2": "SX",
    "code_3": "SXM"
  },
  {
    "name_en": "Syria",
    "name_es": "Siria",
    "dial_code": "+963",
    "code_2": "SY",
    "code_3": "SYR"
  },
  {
    "name_en": "Sri Lanka",
    "name_es": "Sri Lanka",
    "dial_code": "+94",
    "code_2": "LK",
    "code_3": "LKA"
  },
  {
    "name_en": "Sweden",
    "name_es": "Suecia",
    "dial_code": "+46",
    "code_2": "SE",
    "code_3": "SWE"
  },
  {
    "name_en": "Switzerland",
    "name_es": "Suiza",
    "dial_code": "+41",
    "code_2": "CH",
    "code_3": "CHE"
  },
  {
    "name_en": "Suriname",
    "name_es": "Surinam",
    "dial_code": "+597",
    "code_2": "SR",
    "code_3": "SUR"
  },
  {
    "name_en": "Svalbard and Jan Mayen",
    "name_es": "Svalbard y Jan Mayen",
    "dial_code": "+47",
    "code_2": "SJ",
    "code_3": "SJM"
  },
  {
    "name_en": "Thailand",
    "name_es": "Tailandia",
    "dial_code": "+66",
    "code_2": "TH",
    "code_3": "THA"
  },
  {
    "name_en": "Taiwan",
    "name_es": "Taiwán",
    "dial_code": "+886",
    "code_2": "TW",
    "code_3": "TWN"
  },
  {
    "name_en": "Tajikistan",
    "name_es": "Tayikistán",
    "dial_code": "+992",
    "code_2": "TJ",
    "code_3": "TJK"
  },
  {
    "name_en": "British Indian Ocean Territory",
    "name_es": "Territorio Británico del Océano Índico",
    "dial_code": "+246",
    "code_2": "IO",
    "code_3": "IOT"
  },
  {
    "name_en": "French Southern Territories",
    "name_es": "Territorios Australes Franceses",
    "dial_code": "+262",
    "code_2": "TF",
    "code_3": "ATF"
  },
  {
    "name_en": "Timor-Leste",
    "name_es": "Timor-Leste",
    "dial_code": "+670",
    "code_2": "TL",
    "code_3": "TLS"
  },
  {
    "name_en": "Tokelau",
    "name_es": "Tokelau",
    "dial_code": "+690",
    "code_2": "TK",
    "code_3": "TKL"
  },
  {
    "name_en": "Tonga",
    "name_es": "Tonga",
    "dial_code": "+676",
    "code_2": "TO",
    "code_3": "TON"
  },
  {
    "name_en": "Trinidad and Tobago",
    "name_es": "Trinidad y Tobago",
    "dial_code": "+1868",
    "code_2": "TT",
    "code_3": "TTO"
  },
  {
    "name_en": "Turkmenistan",
    "name_es": "Turkmenistán",
    "dial_code": "+993",
    "code_2": "TM",
    "code_3": "TKM"
  },
  {
    "name_en": "Türkiye",
    "name_es": "Turquía",
    "dial_code": "+90",
    "code_2": "TR",
    "code_3": "TUR"
  },
  {
    "name_en": "Tuvalu",
    "name_es": "Tuvalu",
    "dial_code": "+688",
    "code_2": "TV",
    "code_3": "TUV"
  },
  {
    "name_en": "Ukraine",
    "name_es": "Ucrania",
    "dial_code": "+380",
    "code_2": "UA",
    "code_3": "UKR"
  },
  {
    "name_en": "Uruguay",
    "name_es": "Uruguay",
    "dial_code": "+598",
    "code_2": "UY",
    "code_3": "URY"
  },
  {
    "name_en": "Uzbekistan",
    "name_es": "Uzbekistán",
    "dial_code": "+998",
    "code_2": "UZ",
    "code_3": "UZB"
  },
  {
    "name_en": "Vanuatu",
    "name_es": "Vanuatu",
    "dial_code": "+678",
    "code_2": "VU",
    "code_3": "VUT"
  },
  {
    "name_en": "Venezuela",
    "name_es": "Venezuela",
    "dial_code": "+58",
    "code_2": "VE",
    "code_3": "VEN"
  },
  {
    "name_en": "Vietnam",
    "name_es": "Vietnam",
    "dial_code": "+84",
    "code_2": "VN",
    "code_3": "VNM"
  },
  {
    "name_en": "Wallis and Futuna",
    "name_es": "Wallis y Futuna",
    "dial_code": "+681",
    "code_2": "WF",
    "code_3": "WLF"
  },
  {
    "name_en": "Yemen",
    "name_es": "Yemen",
    "dial_code": "+967",
    "code_2": "YE",
    "code_3": "YEM"
  },
  {
    "name_en": "Åland Islands",
    "name_es": "Åland",
    "dial_code": "+358",
    "code_2": "AX",
    "code_3": "ALA"
  }
];
